<template lang="pug">
  .columns.is-vcentered.is-mobile
    template(v-if="type === 'email'")
      .container.has-text-centered.column.p0
        h1 {{ $t('componentes.register.register.titulo') }}
        p {{ $t('componentes.register.register.subTitulo') }}

        br
        .columns.is-centered
          .column.is-one-third
            template(v-if="mostrarInput === 'email'")
              InputText(v-focus="", type="email", :placeholder="$t('componentes.register.register.email.placeholder')", v-model.trim="email", @keyup.enter="checkEmail",
              autocomplete="on", pattern=".{3,}", required="true", key="email")

              .has-text-centered(key="prox")
                Button3d(@click="checkEmail", color="success", size="large", :block="true") {{ $t('componentes.register.register.botaoProximo') }} >

            template(v-else="")
              InputText(type="password", :placeholder="$t('componentes.register.register.senha.placeholder')", v-model="password", @keyup.enter="login",
              autocomplete="off", pattern=".{3,}", required="true", key="pass" ref="password" :disabled="logando")

              .has-text-centered(key="sign")
                Button3d(@click="login", color="success", size="large", :block="true" :disabled="logando") {{ $t('componentes.register.register.botaoEntrar') }}
</template>

<script>
import * as Sentry from '@sentry/vue'
import { gerarUrlGetAuthUserPool } from '../../api'
import { formatarObjetoWebParaSentry } from '../../sentry.ts'
export default {
  mounted () {
    Sentry.captureEvent({
      message: 'Coletor deslogado Register',
      contexts: {
        localStorage: {
          web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
        }
      }
    })
    window.localStorage.clear()
  },
  props: {
    type: {
      'default': 'email',
      type: String,
      validator: function (value) {
        return ['email'].includes(value)
      }
    },
    userId: {
      type: String,
      required: false
    }
  },
  created () {
    this.$store.commit('register/atribuiMostrarInput', 'email')
  },
  computed: {
    email: {
      get () {
        return this.$store.state.register.email
      },
      set (value) {
        this.$store.commit('register/email', value)
      }
    },
    password: {
      get () {
        return this.$store.state.register.password
      },
      set (value) {
        this.$store.commit('register/password', value)
      }
    },
    mostrarInput: {
      get () { return this.$store.state.register.mostrarInput },
      set (value) { this.$store.commit('register/atribuiMostrarInput', value) }
    },
    logando () {
      return this.$store.state.register.logando
    }
  },
  methods: {
    login () {
      this.$store.dispatch('register/registerWithLogin')
    },
    registerWithLogin () {
      this.$store.dispatch('register/registerWithLogin')
    },
    async checkEmail () {
      try {
        const result = await this.$http.post(gerarUrlGetAuthUserPool(), {email: this.email})

        const { userPoolWebClientId, userPoolId, webSamlURL, useCognito } = result.data.success
        this.mostrarInput = 'password'
        this.$nextTick(() => {
          this.$refs.password.focus()
        })

        if (useCognito) {
          if (webSamlURL) {
            // Back said to redirect to this page cuz this user should use cognito
            window.location.href = webSamlURL
          }

          this.$store.commit('cognitoInfo', {userPoolId, userPoolWebClientId, useCognito})
        }
      } catch (e) {
        this.mostrarInput = 'password'
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
        // actualy the API has break, it dont mean that user dont exists, its just better
        // to say this error instead of an error happened
        // this.$swal({type:' info', title: 'Usuário não encontrado', text: 'Esse usuário não foi encontrado no sistema'})
      }
    }
  }
}
</script>
